// @webtoon/psd
// Copyright 2021-present NAVER WEBTOON
// MIT License

/** Image resource types known to @webtoon/psd */
export enum ResourceType {
  GridAndGuides = 1032,
  Slices = 1050,
  ICCProfile = 1039,
  GlobalLightAngle = 1037,
  GlobalLightAltitude = 1049,
  ResolutionInfo = 1005,
}
